export default ['dept', 'univ', 'assn', 'bros', 'inc', 'ltd', 'co']
